import { apiService } from '../_services'

export const sectorService = {
  addSector,
  getSector,
  getSectorByPage,
  getSectorById,
  updateSector,
  deleteSector,
  updateFilters,
  getSectorChartData,
  getCompanyBySectorIndustyChartData
}

function updateFilters(sectorId) {
  return apiService.fetchAuthPost('sector/clear-filter?sectorId='+sectorId,{} )
    .then(response => {
      //console.log(response)
      return response.data
    })
    .catch(error => {
      return error
    })
}

function addSector(sector) {
  console.log(sector,'sector')
  return apiService.fetchAuthPost('sector', sector)
    .then(response => {
      //console.log(response)
      return response.data
    })
    .catch(error => {
      return error
    })
}
function getSector() {
  return apiService.fetchAuthGet('sector')
    .then(response => {
      //console.log(response)
      return response.data
    })
    .catch(error => {
      return error
    })
}
function getSectorChartData() {
  return apiService.fetchAuthGet('sector/chartdata')
    .then(response => {
      //console.log(response)
      return response.data
    })
    .catch(error => {
      return error
    })
}

function getCompanyBySectorIndustyChartData(sectorId,industryId) {
  return apiService.fetchAuthGet('sector/industry/chartdata?sectorId='+sectorId+'&industryId='+industryId)
    .then(response => {
      //console.log(response)
      return response.data
    })
    .catch(error => {
      return error
    })
}

function getSectorByPage(start, pageSize, search,sortBy) {
  return apiService.fetchAuthGet('sector/page?start=' + start + '&pageSize=' + pageSize + '&search=' + search, '&sortBy='+sortBy)
    .then(response => {
      //console.log(response)
      return response.data
    })
    .catch(error => {
      return error
    })
}

function getSectorById(id) {
  return apiService.fetchAuthGet('sector/' + id)
    .then(response => {
      //console.log(response)
      return response.data
    })
    .catch(error => {
      return error
    })
}
function updateSector(sector, id) {
  console.log(sector,'sector')
  return apiService.fetchAuthPut('sector/' + id, sector)
    .then(response => {
      //console.log(response)
      return response
    })
    .catch(error => {
      return error
    })
}
function deleteSector(id,userId){
  return apiService.fetchAuthPut('sector/delete/'+id+'/'+userId,{})
    .then(response => {
      //console.log(response)
      return response.data
    })
    .catch(error => {
      return error
    })
}
